import { combineReducers } from "@reduxjs/toolkit";

import { privateApi } from "../api/private";
import { publicApi } from "../api/public";
import authReducer from "./auth";
import themeReducer from "./theme";

const rootReducer = combineReducers({
  [privateApi.reducerPath]: privateApi.reducer,
  [publicApi.reducerPath]: publicApi.reducer,
  auth: authReducer,
  theme: themeReducer,
});
export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
